import * as React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle, faArrowsAlt } from '@fortawesome/free-solid-svg-icons'
import { SortableHandle } from 'react-sortable-hoc';
import { localization, LocHelperInstance, langChangedName } from '../../localization/localization';

import LoadingImage from './loading-image.component';
import { DeleteIcon } from '../../icons/pt-icon-delete';

/**
 * Handle on image for draging image
 */
const DragHandle = SortableHandle(() => (
    <span className="drag-handle" onClick={(e) => {e.stopPropagation(); e.preventDefault()}}>
        <FontAwesomeIcon icon={faArrowsAlt} color={'gray'}/>
    </span>
)); 

export interface ILogoGalleryImageData {
    id: string;
    isMotive: boolean;
    isGlobal: boolean;
    src: string;
    showSelected: boolean;
    onSelection(id: string): void;
    showDeleteBtn: boolean;
    onImageDelete(id: string): void;
    format: string;
    created: Date | null;
    useDarkBackground: boolean;
}

export interface ILogoGalleryImageProps {
    image: ILogoGalleryImageData;
    logoTitle?: string;
}

export interface ILogoGalleryImageState {
    initialLoading: boolean;
    isLoading: boolean;
    loadingText?: string;
}

export class LogoGalleryImage extends React.PureComponent<ILogoGalleryImageProps,ILogoGalleryImageState> {
    private langUpdateHandle = () => { this.forceUpdate(); /* to update logo created date to localized format */ };

    constructor(props: ILogoGalleryImageProps) {
        super(props);
        this.state = {
            isLoading: true,
            loadingText: 'Loading logo...',
            initialLoading: true
        };
    }

    public componentDidMount() {
        LocHelperInstance.langChanged.addListener(langChangedName, this.langUpdateHandle);        
        this.langUpdateHandle();
    }

    public componentWillUnmount() {
        LocHelperInstance.langChanged.removeListener(langChangedName, this.langUpdateHandle);
    }

    private onDeleteBtnClick(event: React.MouseEvent<HTMLDivElement>) {
        event.preventDefault();

        if (this.props.image.showDeleteBtn) {
            event.stopPropagation();
            this.props.image.onImageDelete(this.props.image.id);
        }
    }

    private OnImageLoading() {
        this.setState({
            isLoading: true
        });
    }

    private onImageLoaded() {
        this.setState({
            isLoading: false,
            loadingText: undefined,
            initialLoading: false
        });
    }

    public render() {
        let deleteBtn: JSX.Element | null = null;
        if (this.props.image.showDeleteBtn) {
            deleteBtn = (
                <div className="delete-btn unselectable"
                    onClick={(e) => {
                        this.onDeleteBtnClick(e)}
                    }>
                        <DeleteIcon />
                </div>
            );
        }

        let leftIcon: JSX.Element | null = null;
        if (this.props.image.isMotive) {
            leftIcon = (
                <span className="gallery-image-left-icon">
                    {localization.commonLoc.motive}
                </span>)
        } else {
            leftIcon = (
                <span className="gallery-image-left-icon">
                    {`${localization.commonLoc.logo} (${this.props.image.format})`}
                </span>)
        }

        let rightIcon: JSX.Element | null = null;
        if (this.props.image.created) {
            rightIcon = (
                <span className="gallery-image-right-icon">
                    {new Date(this.props.image.created).toLocaleDateString(localization.getLanguage())}
                </span>)
        }

        let dragHandle: JSX.Element | null = null;
        if (!this.props.image.isGlobal) {
            dragHandle = <DragHandle />
        }

        return (
            <div title={this.props.logoTitle}
                className={'logo-image-root ' + (this.props.image.useDarkBackground ? 'logo-image-root-dark' : '')}
                onClick={() => this.props.image.onSelection(this.props.image.id)}>
                {dragHandle}
                {deleteBtn}
                {leftIcon}
                {rightIcon}
                <LoadingOverlay
                    active={this.state.isLoading}
                    spinner={true}
                    text={this.state.loadingText}
                    fadeSpeed={0}
                    classNamePrefix="loading_overlay_"
                >                    
                    <div className="logo-image-content" >                        
                        <LoadingImage
                            src={this.props.image.src}
                            onLoadStarted={() => this.OnImageLoading()}
                            onLoadCompleted={res => this.onImageLoaded()}
                        />
                    </div>
                </LoadingOverlay>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/components/gallery/logo-gallery-image.component.tsx